<template>
    <b-modal centered ref="confirm" no-close-on-backdrop hide-header hide-footer title="Bạn có muốn xóa ?">
        <div style="text-align: center">
            <div class="mb-4 text-left">Bạn có muốn xóa "{{name}}"?</div>
            <base-button button="Hủy" size="sm" class="btn search-information-btn mb-3 mr-2 float-right" variant="outline-secondary" @click="hideModal()">Hủy
            </base-button>
            <base-button button="Xóa" size="sm" class="btn search-information-btn mb-3 mr-2 float-right" variant="primary" @click="onSave()">Tạo</base-button>
        </div>
    </b-modal>
</template>
<script>
export default {
  name: "ModalConfirm",
  props: {
    name: {
      type: String,
      default: ""
    }
  },
  methods: {
    hideModal() {
      this.$refs.confirm.hide();
    },
    onSave() {
        this.$emit("onDelete");
        this.hideModal()
    },
  }
};
</script>
